import { render, staticRenderFns } from "./doaApprovalNode.vue?vue&type=template&id=12ca3b0e&scoped=true&"
import script from "./doaApprovalNode.vue?vue&type=script&lang=js&"
export * from "./doaApprovalNode.vue?vue&type=script&lang=js&"
import style0 from "./doaApprovalNode.vue?vue&type=style&index=0&id=12ca3b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca3b0e",
  null
  
)

export default component.exports